<script lang="ts">
	import type { Notification } from "$lib/def/landing";
	import { createEventDispatcher } from "svelte";

	export let data: Notification;
	const dispatch = createEventDispatcher();

	$: note = Object.keys(data).map((type) => ({type,...data[type as 'capacity_delay' | 'breakfast']})).pop();

	let cool = note?.refresh_delay ? false : true;
	$: if (note?.refresh_delay)
	setTimeout(() => (cool = true), note.refresh_delay * 1000);

	const action = () => {
		dispatch("action", note);
		if (note?.refresh_delay) {
			cool = false;
			setTimeout(() => (cool = true), note.refresh_delay * 1000);
		}
	};
</script>

{#if note}
	<div class="notification {note.type}">
		<p class="label-xl bold">{note.title}</p>
		<p class="label-xl book">{note.sub_title}</p>
		{#if note.button_text}
			<button class="button secondary label-m" on:click={action}>
				{#if cool}
				<span class="icon-refresh-20"></span> {note.button_text}
				{:else}
					<span class="icon-arrow-right-16"></span> Check back in <b>{note.refresh_delay} seconds</b>
				{/if}
			</button>
		{/if}
	</div>
{/if}

<style lang="scss">
	@use "color";
	.notification {
		background-color: color.$li-food-note;
		padding: 1rem;
		text-align: center;
		border-radius: 20px;
		color: color.$white;
		p { margin: 0.3rem; }
		> button {
			margin-top: 1rem;
			padding: 0.3rem 0.75rem;
			outline: 2px solid color.$on-surface;
			font-weight: 400;
			span { margin-right: .25rem; }
		}
	}
</style>
